import React, { useEffect, useState } from 'react';
import { Quote } from 'lucide-react';

const coachingQuotes = [
  {
    quote: "Winning isn't everything, but wanting to win is.",
    author: "Vince Lombardi, NFL Coach"
  },
  {
    quote: "The difference between the impossible and the possible lies in a man's determination.",
    author: "Tommy Lasorda, MLB Manager"
  },
  {
    quote: "In the end, it's extra effort that separates a winner from second place.",
    author: "Jesse Owens, Olympic Runner"
  },
  {
    quote: "It's not the will to win that matters—everyone has that. It's the will to prepare to win that matters.",
    author: "Paul 'Bear' Bryant, Alabama Football Coach"
  },
  {
    quote: "Most people run a race to see who is fastest. I run a race to see who has the most guts.",
    author: "Steve Prefontaine, Olympic Runner"
  },
  {
    quote: "It's not the disability that defines you; it's how you deal with the challenges.",
    author: "Jim Abbott, MLB Player"
  },
  {
    quote: "Do you know what my favorite part of the game is? The opportunity to play.",
    author: "Mike Singletary, NFL Player"
  },
  {
    quote: "I've worked too hard and too long to let anything stand in the way of my goals.",
    author: "Mia Hamm, USWNT Soccer Player"
  },
  {
    quote: "The time when there is no one there to feel sorry for you or to cheer for you is when a player is made.",
    author: "Tim Duncan, NBA Player"
  },
  {
    quote: "The Spirit of Sports gives each of us who participate an opportunity to be creative.",
    author: "Dan O'Brien, Olympic Decathlete"
  },
  {
    quote: "I always tell kids, you have two eyes and one mouth. Keep two open and one closed.",
    author: "Gordie Howe, NHL Player"
  },
  {
    quote: "Sports creates a bond between contemporaries that lasts a lifetime.",
    author: "Bob Cousy, NBA Player"
  },
  {
    quote: "Competitive sports are played mainly on a five-and-a-half inch court, the space between your ears.",
    author: "Bobby Jones, Golf Champion"
  },
  {
    quote: "I have always tried to be true to myself, to pick those battles I felt were important.",
    author: "Arthur Ashe, Tennis Champion"
  },
  {
    quote: "Every kid around the world who plays soccer wants to be Pele.",
    author: "Pele, Soccer Legend"
  },
  {
    quote: "Treat a person as he is, and he will remain as he is. Treat him as he could be, and he will become what he should be.",
    author: "Jimmy Johnson, NFL Coach"
  },
  {
    quote: "Never give up, never give in, and when the upper hand is ours, may we have the ability to handle the win with the dignity that we absorbed the loss.",
    author: "Doug Williams, NFL Player"
  },
  {
    quote: "Pain is temporary. It may last a minute, or an hour, or a day, or a year, but eventually it will subside.",
    author: "Lance Armstrong, Cyclist"
  },
  {
    quote: "Baseball is 90 percent mental. The other half is physical.",
    author: "Yogi Berra, MLB Player"
  },
  {
    quote: "You have to be able to center yourself, to let all of your emotions go.",
    author: "Kareem Abdul-Jabbar, NBA Player"
  },
  {
    quote: "Doctors and scientists said that breaking the four-minute mile was impossible.",
    author: "Roger Bannister, Olympic Runner"
  },
  {
    quote: "My dad has always taught me these words: care and share.",
    author: "Tiger Woods, Golf Champion"
  },
  {
    quote: "Some people believe football is a matter of life and death. I can assure you it is much, much more important than that.",
    author: "Bill Shankly, Soccer Manager"
  },
  {
    quote: "I'll let the racket do the talking.",
    author: "John McEnroe, Tennis Player"
  },
  {
    quote: "The way a team plays as a whole determines its success.",
    author: "Babe Ruth, MLB Player"
  },
  {
    quote: "It's not the size of the dog in the fight, but the size of the fight in the dog!",
    author: "Archie Griffin, NFL Player"
  },
  {
    quote: "There are only two options regarding commitment. You're either IN or you're OUT.",
    author: "Pat Riley, NBA Coach"
  },
  {
    quote: "You have to have the mentality of executing your game when you don't feel like there's a lot of hope.",
    author: "Andre Agassi, Tennis Player"
  },
  {
    quote: "If you can believe it, the mind can achieve it.",
    author: "Ronnie Lott, NFL Player"
  },
  {
    quote: "Ask not what your teammates can do for you. Ask what you can do for your teammates.",
    author: "Magic Johnson, NBA Player"
  },
  {
    quote: "Leadership is a matter of having people look at you and gain confidence.",
    author: "Tom Landry, NFL Coach"
  },
  {
    quote: "Football doesn't build character, it reveals character!",
    author: "Marv Levy, NFL Coach"
  },
  {
    quote: "If you train hard, you'll not only be hard, you'll be hard to beat.",
    author: "Herschel Walker, NFL Player"
  },
  {
    quote: "To succeed...You need to find something to hold on to, something to motivate you, something to inspire you.",
    author: "Tony Dorsett, NFL Player"
  },
  {
    quote: "The difference between the old ballplayer and the new ballplayer is the jersey.",
    author: "Steve Garvey, MLB Player"
  },
  {
    quote: "The fewer rules a coach has, the fewer rules there are for players to break.",
    author: "John Madden, NFL Coach"
  },
  {
    quote: "One day of practice is like one day of clean living. It doesn't do you any good.",
    author: "Abe Lemons, College Basketball Coach"
  },
  {
    quote: "I figure practice puts your brains in your muscles.",
    author: "Sam Snead, Golf Champion"
  },
  {
    quote: "An athlete cannot run with money in his pockets. He must run with hope in his heart and dreams in his head.",
    author: "Emil Zatopek, Olympic Runner"
  },
  {
    quote: "The more I practice, the luckier I get.",
    author: "Gary Player, Golf Champion"
  },
  {
    quote: "When you get that nice celebration coming into the dugout and you're getting your ass hammered by guys—there's no better feeling than to have that done.",
    author: "Matt Stairs, MLB Player"
  },
  {
    quote: "You play to win the game...Hello. You play to win the game.",
    author: "Herman Edwards, NFL Coach"
  },
  {
    quote: "If a tie is like kissing your sister, losing is like kissing your grandmother with her teeth out!",
    author: "George Brett, MLB Player"
  },
  {
    quote: "Baseball is the only field of endeavor where a man can succeed three times out of ten and be considered a good performer.",
    author: "Ted Williams, MLB Player"
  },
  {
    quote: "Baseball is like church. Many attend but few understand.",
    author: "Wes Westrum, MLB Manager"
  },
  {
    quote: "Most football players are temperamental. That's 90 percent temper and 10 percent mental.",
    author: "Doug Plank, NFL Player"
  },
  {
    quote: "Basketball is like war in that offensive weapons are developed first, and it always takes a while for the defense to catch up.",
    author: "Red Auerbach, NBA Coach"
  },
  {
    quote: "You win some, lose some, and wreck some.",
    author: "Dale Earnhardt, NASCAR Driver"
  },
  {
    quote: "Age is no barrier. It's a limitation you put on your mind.",
    author: "Jackie Joyner-Kersee, Olympic Athlete"
  }
];

const QuoteOfTheDay: React.FC = () => {
  const [quote, setQuote] = useState<{ quote: string; author: string } | null>(null);

  useEffect(() => {
    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];
    
    // Use the date as a seed for the random number generator
    const seed = today.split('-').reduce((acc, val) => acc + parseInt(val), 0);
    
    // Select a quote based on the date
    const quoteIndex = seed % coachingQuotes.length;
    setQuote(coachingQuotes[quoteIndex]);
  }, []);

  if (!quote) return null;

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg mb-8">
      <div className="flex items-start gap-4">
        <div className="text-primary">
          <Quote size={24} />
        </div>
        <div>
          <p className="text-lg font-medium text-stone-800 mb-2">{quote.quote}</p>
          <p className="text-sm text-stone-600">— {quote.author}</p>
        </div>
      </div>
    </div>
  );
};

export default QuoteOfTheDay; 